angular.module('impactx').service('$context', ContextProvider);

ContextProvider.$inject = ['$q', '$config', 'TranslationService', 'ReloginExternalService', 'PollingService', 'MessageService',
    '$rootScope', '$workspaceIdHolder', 'BasketService', 'PaginationService', '$locale', '$mdDateLocale', 'BANFService', 'FreeFromService',
    'AppConfiguration', 'sidebarShow'];

function ContextProvider($q, $config, TranslationService, ReloginExternalService, PollingService, MessageService, $rootScope,
                         $workspaceIdHolder, BasketService, PaginationService, $locale, $mdDateLocale, BANFService, FreeFromService,
                         AppConfiguration, sidebarShow) {
    /**
     * Initialize all variables in this method
     */
    var context = this;

    this.reset = function() {
        context.wasInitialized = false;
        context.basketCount = 0;
        context.rfqsBasketCount = 0;
        context.basketIsCompanyTemplate = false;
        context.basketIsUserTemplate = false;
        context.basketIsDisposition = false;
        context.hasUniteItems = false;
        context.uniteOptimizationRunning = false;
        context.userImageUrl = null;
        context.infoMessageCount = 0;
        context.todoMessageCount = 0;
        context.moreInfoMessages = false;
        context.moreTodoMessages = false;
        context.$securityManager = {};
        context.sideBar = {};
        context.loginToLastWorkspace = false;
        context.showBasket = {value: false};
        context.showSupplierBasket = {value: false};
        context.hasSupplierBasket = {value: false, id: 0};
        context.hasRFQSSearch = {value: false, id: 0};
        context.hasRFQHSearch = {value: false, id: 0};
        context.rfqcSearch = {id: 0};
        context.supplierSearch = {id: 0};
        context.tenderSearch = {id: 0};
        context.lotSearch = {id: 0};
        context.hasActiveProductView = {value: false, id: 0};
        context.hasActiveThemeWorld = {value: false, id: 0};
        context.hasActiveThemeWorldSearch = {value: false, id: 0, theme: undefined};
        context.hasActiveShopView = {value: false, id: 0};
        context.showSearch = {value: false};
        context.userId = {value: 0};
        context.comIdForThemes = {value: 0};
        context.isClassificationSuggestActivated = {value: false};
        context.exitMessageDisabled = {value: false};
        context.company = {};
        context.user = {};
        context.customerServiceUser = {value: null};
        context.globalActions = [];
        context.neededDataInput = null;

        MessageService.stopInfoMessagePolling();
        MessageService.stopToDoMessagePolling();
    };

    this.reset();

    this.setNeededDataInput = function (data) {
        context.neededDataInput = data;
    };

    this.needsDataInput = function () {
        return context.neededDataInput && (context.neededDataInput.doctorData || context.neededDataInput.termsOfUseData)
    }

    this.refreshBasket = function($scope, dataGen, $context) {
        if($context.$securityManager.isProcessAllowed("ViewBasket") || $context.$securityManager.isProcessAllowed("ViewSupplierBasket")) {
            return dataGen.getData($scope, {}, "/basket/overview", null, true).then(function() {
                var data = $scope.data;
                if(data !== null && data !== undefined) {
                    $context.basketCount = data.numberOfItems;
                    $context.basketIsCompanyTemplate = data.basketIsCompanyTemplate;
                    $context.basketIsUserTemplate = data.basketIsUserTemplate;
                    $context.basketIsDisposition = data.basketIsDisposition;
                    $context.hasUniteItems = data.hasUniteItems;
                }
            });
        }
    };

    this.refreshSearchInfo = function($scope, dataGen, $context) {
        if($context.$securityManager.isProcessAllowed("Search")) {
            return dataGen.getData($scope, {}, "/search/info", null, true).then(function() {
                var data = $scope.data;
                if(data !== null && data !== undefined) {
                    $context.hasSupplierBasket.value = data.hasSupplierBasket;
                    $context.hasSupplierBasket.id = data.supplierBasketId;
                    $context.hasRFQSSearch.value = data.hasRFQSSearch;
                    $context.hasRFQSSearch.id = data.rfqsSearchId;
                    $context.hasRFQSSearch.rfqhId = data.rfqhIdInRfqsSearch;
                    $context.hasRFQHSearch.value = data.hasRFQHSearch;
                    $context.hasRFQHSearch.id = data.rfqhSearchId;
                    $context.rfqcSearch.id = data.rfqcSearchId;
                    $context.supplierSearch.id = data.supplierId;
                    $context.tenderSearch.id = data.tenderSearchId;
                    $context.lotSearch.id = data.lotSearchId;
                    $context.isClassificationSuggestActivated.value = data.isClassificationSuggestActivated;
                    $context.hasActiveProductView.value = data.hasActiveProductView;
                    $context.hasActiveProductView.id = data.productViewId;
                    $context.hasActiveThemeWorld.value = data.hasActiveThemeWorld;
                    $context.hasActiveThemeWorld.id = data.themeWorldId;
                    $context.hasActiveThemeWorldSearch.theme = data.themeWorldTheme;
                    $context.hasActiveThemeWorldSearch.value = data.hasActiveThemeWorldSearch;
                    $context.hasActiveThemeWorldSearch.id = data.themeWorldSearchId;
                    $context.hasActiveShopView.value = data.hasActiveShopView;
                    $context.hasActiveShopView.id = data.shopViewId;
                    $workspaceIdHolder.themeWorldTheme.value = data.themeWorldTheme;
                }
                TranslationService.add("searchPlaceHolder", data.searchPlaceHolder)
            });
        }
    };

    this.startInfoMessagePolling = function() {
        MessageService.startInfoMessagePolling();
    };

    this.startToDoMessagePolling = function() {
        MessageService.startToDoMessagePolling();
    };

    this.startPushMessageLoginFetch = function(dataGen, $mdDialog) {
        dataGen.getData({}, {}, "/pushmessage/login").then(function(data) {
            if(data.data && data.data.messages.length > 0) {
                $mdDialog.show({
                    templateUrl: "modules/pushmessage/templates/login-push-message.html",
                    controller: "PushMessageLoginCtrl",
                    controllerAs: "ctrl",
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    escapeToClose: false,
                    locals: {
                        messages: data.data.messages,
                        trns: data.trns
                    }
                });
            }
        });
    };

    this.refreshUser = function($scope, dataGen, $context) {
        dataGen.getData($scope, {}, "/user/overview", null, true).then(function() {
            var data = $scope.data;
            if(data !== null && data !== undefined) {
                $context.userImageUrl = data.imageUrl ? data.imageUrl : "";
                $context.loginToLastWorkspace = data.loginToLastWorkspace;
                $context.company = data.company;
                $context.user = {
                    id: data.id,
                    firstName: data.firstName,
                    lastName: data.lastName,
                    lastLogin: data.lastLogin,
                    language: data.language
                }
                $rootScope.language = data.language;

                var dateformat = data.dateFormat;
                if(dateformat) {
                    $config.setDateFormat(dateformat);
                }
            }
        });
    };

    this.init = function ($scope, dataGen, $securityManager) {
        this.reset();
        this.$securityManager = $securityManager;
        if ($securityManager.isAuthorized()) {
            return dataGen.getData($scope, {}, "/processes/get").then(function () {
                return TranslationService.initialize(dataGen).then(function () {
                    var data = $scope.data;
                    if (data) {
                        $securityManager.setAllowedProcesses(data.processes);
                        context.showSearch.value = $securityManager.isProcessAllowed("Search");
                        context.showBasket.value = $securityManager.isProcessAllowed("ViewBasket");

                        var isExternalGuest = $securityManager.isProcessAllowed("OrderGuestBasket") && !$securityManager.isSuperUser();
                        context.isExternalGuest = {value: isExternalGuest};
                        context.exitMessageDisabled = {value: data.exitMessageDisabled};
                        context.customerServiceUser = {value: data.customerServiceUser};

                        //add the user id here, because we need the user id for the cookies at the same time we need the processes.
                        context.userId.value = data.userId;
                        context.comIdForThemes.value = data.comIdForThemes;
                        if (data.banfAllowed) {
                            context.globalActions.push({label: TranslationService.get("newBanf"), func: AppConfiguration.get('useFFOfferDialog') ? BANFService.showAddBANFOfferDialog : BANFService.showAddBANFDialog});
                        }
                        if (data.freeFormAllowed) {
                            context.globalActions.push({label: TranslationService.get("newFreeForm"), func: AppConfiguration.get('useFFOfferDialog') ? FreeFromService.showAddFreeFormOfferDialog : FreeFromService.showAddFreeFormDialog});
                        }
                        BasketService.initLandingPages();
                        BasketService.setLandingPageIndex(data.basketLandingPage);
                        PaginationService.setNumberOfLines(data.numberOfLinesForLists);
                        $workspaceIdHolder.suffixForTheme.value = context.getSuffixForTheme();
                        ReloginExternalService.initialize(data.reLoginButton, data.reLoginMessage, data.reLoginUrl, data.isExternalUser, data.reLoginUrlUser);
                        if (!context.showBasket.value) {
                            context.showSupplierBasket.value = $securityManager.isProcessAllowed("ViewSupplierBasket");
                        }
                        context.wasInitialized = true;

                        $locale.NUMBER_FORMATS.DECIMAL_SEP = data.decimalSeparator;
                        $locale.NUMBER_FORMATS.GROUP_SEP = data.groupingSeparator;

                        $rootScope.$broadcast('loginSuccess');
                        $mdDateLocale.firstDayOfWeek = data.firstDayOfWeek;

                        if (data.neededDoctorDataInput || data.termsOfUseData) {
                            context.neededDataInput = {doctorData: data.neededDoctorDataInput, termsOfUseData: data.termsOfUseData, trns: $scope.trns};
                            sidebarShow.close();
                            sidebarShow.setToggleIsHidden(true);
                        }
                        else {
                            sidebarShow.setToggleIsHidden(false);
                        }
                    }
                });
            });
        }
        return $q.when();
    };

    this.needsInit = function() {
        return !context.wasInitialized;
    };

    this.hasCompany = function () {
        return !!impactX.isDefined(context, 'company.id');
    };
    
    this.companyId = function () {
        return context.hasCompany() ? context.company.id : 0;
    };


    this.invalidateSidebar = function (dataGen,  $context, $workspace) {
        var tempScope = {};
        dataGen.getData(tempScope, {key: $workspace.getCurrentWorkspaceId().value}, "/workspace/invalidate").then(function() {
            var data = tempScope.data;
            if(data !== null && data !== undefined) {
                if(data) {
                    $context.sideBar = data;
                }
            }
        });
    };

    this.getSuffixForTheme = function () {
        return context.comIdForThemes.value > 0 ? context.comIdForThemes.value : "";
    };

    this.$get = function() {
        return {
            refreshBasket: this.refreshBasket,
            refreshSearchInfo: this.refreshSearchInfo,
            basketCount: this.basketCount,
            rfqsBasketCount: this.rfqsBasketCount,
            showBasket: this.showBasket,
            showSupplierBasket: this.showSupplierBasket,
            hasActiveProductView: this.hasActiveProductView,
            hasActiveThemeWorld: this.hasActiveThemeWorld,
            hasActiveThemeWorldSearch: this.hasActiveThemeWorldSearch,
            hasActiveShopView: this.hasActiveShopView,
            hasSupplierBasket: this.hasSupplierBasket,
            hasRFQSSearch: this.hasRFQSSearch,
            hasRFQHSearch: this.hasRFQHSearch,
            rfqcSearch: this.rfqcSearch,
            supplierSearch: this.supplierSearch,
            tenderSearch: this.tenderSearch,
            lotSearch: this.lotSearch,
            basketIsCompanyTemplate: this.basketIsCompanyTemplate,
            basketIsUserTemplate: this.basketIsUserTemplate,
            startInfoMessagePolling: this.startInfoMessagePolling,
            startToDoMessagePolling: this.startToDoMessagePolling,
            startPushMessageLoginFetch: this.startPushMessageLoginFetch,
            infoMessageCount: this.infoMessageCount,
            todoMessageCount: this.todoMessageCount,
            moreInfoMessages: this.moreInfoMessages,
            moreTodoMessages: this.moreTodoMessages,
            refreshUser: this.refreshUser,
            userImageUrl: this.userImageUrl,
            loginToLastWorkspace: this.loginToLastWorkspace,
            hasCompany: this.hasCompany,
            user: this.user,
            init: this.init,
            needsInit: this.needsInit,
            $securityManager: this.$securityManager,
            reset: this.reset,
            exitMessageDisabled: this.isExitMessageDisabled.value,
            companyId: this.companyId,
            invalidateSidebar: this.invalidateSidebar,
            getSuffixForTheme: this.getSuffixForTheme,
            comIdForThemes: context.comIdForThemes,
            globalActions: this.globalActions,
            customerServiceUser: this.customerServiceUser
        }
    }
}